import { Text } from "@mantine/core";
import { modals } from "@mantine/modals";

export function confirmRemoveImport(fileName, onConfirm) {
  modals.openConfirmModal({
    title: "Remove this file?",
    centered: true,
    children: (
      <Text size="sm">
        {fileName
          ? `${fileName} will no longer show in your imports.`
          : "This file will no longer show in your imports."}
      </Text>
    ),
    labels: { confirm: "Remove", cancel: "Cancel" },
    confirmProps: { color: "red" },
    onConfirm,
  });
}
